module.exports = __webpack_public_path__ + "img/photo1.d5664458.jpg";